module.exports = __webpack_public_path__ + "img/qr-code.ad8359b5.svg";